import { action, observable } from 'mobx';
import { deleteCookie, isLocalStorageSupported } from '../utils/helpers';
import { checkAuthentication, getUser, getBroadcastMessages } from '../lib/apiClient';
import  secureLocalStorage  from  "react-secure-storage";

function SessionStore() {

  let obx = observable({
    authenticated: false,
    user: null,
    firstName: "",
    lastName: "",
    email : "",
    role: 'learner',
    mode: 'production',
    ids: {},
    isSetup: false,
    hasSessionStorage: isLocalStorageSupported(),
    tokenSet: false,
    activeBroadcasts : [],
    sidArray : [],
    matchingBroadcasts : [],
    selectedBroadcastMessage : null,
    getLocalStorage: action(function(data) {
      obx.userData = data;
    }),
    
    setup: action (async function() {
        try {
          
          const authenticationCheck = await checkAuthentication();

          obx.role = authenticationCheck.data.role;
          obx.mode = authenticationCheck.data.mode;

          obx.ids.deploymentSid = authenticationCheck.data?.deploymentSid;
          obx.ids.courseSid = authenticationCheck.data?.courseSid;
          obx.ids.installSid = authenticationCheck.data?.installSid;
          obx.ids.courseSid = authenticationCheck.data?.courseSid;
          obx.ids.userSid = authenticationCheck.data?.userSid;
          obx.ids.integrationSid = authenticationCheck.data?.integrationSid;
          obx.ids.enrollmentSid = authenticationCheck.data?.enrollmentSid;

          // now get the user profile information...
          const user = await getUser(obx.ids.installSid, obx.ids.userSid);
          
          obx.ids.userSid = authenticationCheck.data?.userSid;

          obx.firstName = user.data?.firstName;
          obx.lastName = user.data?.lastName;
          obx.email = user.data?.email;

          const activeBroadcasts = await getBroadcastMessages();

          if(activeBroadcasts.successful){
            obx.activeBroadcasts = activeBroadcasts.data;
          }else{
            obx.activeBroadcasts = [];  
          }

          obx.setMatchingBroadcasts();

          obx.isSetup = true;

        return true;
      }
      catch (err) {
        return false;
      }
    }),

    setMatchingBroadcasts: action(async function () {
      // Create a Set from the values of the SIDs object for quick lookup
      const sidsSet = new Set(Object.values(obx.ids));

      // Filter notifications where any target's Sid__c is in the sidsSet
      const filteredNotifications = obx.activeBroadcasts.filter(notification => 
          notification.targets.some(target => sidsSet.has(target.sid))
      );

      obx.matchingBroadcasts = filteredNotifications || [];

      return true;    
    }),

    getUser: action (async function(sessionToken, outsetaToken) {
      
      try {
      
        const result = {
            authenticated: true,
            user: null,
            message: null
        }

        if(result.authenticated){
          

          //secureLocalStorage.setItem('authenticated', true);
          
        }else{
          secureLocalStorage.clear('user');
        }

        return result;
      }
      catch (err) {
        return err;
      }
    }),

    removeLocalStorage: action(function() {
      if(obx.hasSessionStorage) {
        secureLocalStorage.removeItem('userData');
      } else {
        deleteCookie('userData');
      }
    }),
    
    logout: action(async function () {
      secureLocalStorage.clear();
      obx.resetStores();
      return true;    
    }),

    resetStores: action(function() {
      // Reset session store (this)
      obx.userData = null;
      obx.profile = null;
      obx.account = null;
      obx.bucket = null;
      obx.buckets = [];
      obx.streamViews = [];
    })
    
  });

  
  async function init() {
    await obx.setup();
  }

  init();

  return obx;

}

export default SessionStore();